import React, { Component } from "react";
import auth from "../../auth/authHelper";
import read from "../../auth/authUser";
import Loader from "../../Loader/Loader";
import axios from "axios";

export default class MyAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: undefined,
      loading: false,
      error_message: undefined,
      password: "",
      confirm_password: ""
    };
  }

  componentDidMount = () => {
    var id = auth.isAuthenticated().user._id;
    this.init(id);
  };

  init = userId => {
    const jwt = auth.isAuthenticated();
    read(
      {
        userId: userId
      },
      { t: jwt.token }
    ).then(data => {
      if (data.error) {
        this.setState({ redirectToSignin: true });
      } else {
        this.setState({
          user: data
        });
      }
    });
  };

  onPasswordSave = () => {
    if (this.state.password === this.state.confirm_password) {
      var user = { ...this.state.user };
      user.password = this.state.password;
      console.log(user);
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "jwt"
      );
      axios
        .post("/api/admin/changepass", user)
        .then(() => {
          this.setState({
            password: "",
            confirm_password: ""
          });
        })
        .then(res => {
          return Promise.resolve(1);
        })
        .catch(e => console.log(e));
    } else {
      console.log("Passwords do not match!");
      this.setState({
        error_message: "Passwords do not match."
      });
    }
  };

  changeValue = (item, val) => {
    this.setState({
      [item]: val,
      error_message: undefined
    });
  };

  componentDidMount() {
    setTimeout(() => this.setState({ loading: false }), 1000);
  }

  render() {
    if (!this.state.user) {
      return <Loader />;
    } else {
      return (
        <div className="container">
          <h4>My Account</h4>
          <div className="card bg-light mb-3" style={{ "maxWidth": "18rem" }}>
            <div className="card-header">First Name</div>
            <div className="card-body">
              <h5 className="card-title">{this.state.user.first_name}</h5>
            </div>
            <div className="card-header">Last Name</div>
            <div className="card-body">
              <h5 className="card-title">{this.state.user.last_name}</h5>
            </div>
            <div className="card-header">Email</div>
            <div className="card-body">
              <h5 className="card-title">{this.state.user.email}</h5>
            </div>
          </div>

          <h5>Change Password</h5>

          <div className="input-group mb-3" style={{ "maxWidth": "18rem" }}>
            <div
              className="input-group-prepend"
              style={{ "maxWidth": "10rem" }}
            >
              <span className="input-group-text" id="basic-addon1">
                New Password
              </span>
            </div>
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={this.state.password}
              onChange={e => this.changeValue("password", e.target.value)}
            />
          </div>
          <div className="input-group mb-3" style={{ "maxWidth": "18rem" }}>
            <div
              className="input-group-prepend"
              style={{ "maxWidth": "10rem" }}
            >
              <span className="input-group-text" id="basic-addon1">
                Confirm Password
              </span>
            </div>
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              value={this.state.confirm_password}
              onChange={e =>
                this.changeValue("confirm_password", e.target.value)
              }
            />
          </div>

          {this.state.error_message && (
            <p style={{ color: "red" }}>{this.state.error_message}</p>
          )}
          <button
            className="btn btn-light"
            onClick={() => this.onPasswordSave()}
          >
            Save
          </button>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/MyAccount.js